// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyAvailabilityWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyAvailabilityWebApiHandler_confirm } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  ListingAlias,
  UserPropertyAvailabilityConfirmResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface ConfirmParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyAvailabilityWebApiHandler_confirm_Args {
  getParams: ConfirmParams;
}

export type RentalManagerUserPropertyAvailabilityWebApiHandler_confirm_Options = UseMutationOptions<
  UserPropertyAvailabilityConfirmResponseWebDto,
  unknown,
  RentalManagerUserPropertyAvailabilityWebApiHandler_confirm_Args
>;

/**
 * Confirm listing availability
 */
export const useRentalManagerUserPropertyAvailabilityWebApiHandler_confirm = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyAvailabilityWebApiHandler_confirm_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyAvailabilityWebApiHandler_confirm_Args) =>
      RentalManagerUserPropertyAvailabilityWebApiHandler_confirm(args.getParams, httpClient),
  });
};
